'use strict';

require('slick');
var throttle = require('lodash/function/throttle');
var debounce = require('lodash/function/debounce');

var triggerCustomEvent = require('trigger-custom-event');
var bodyStateDetection = require('body-state-detection');

var appDom = require('./app-dom');
var dataMgr = require('./data-mgr');
var slideshowCellsJst = require('./slideshow-cells-jst');
var slideshowImageLoader = require('./slideshow-image-loader');
var slideshowIntro = require('./slideshow-intro');
var slideshowImageMeta = require('./slideshow-image-meta');
var slideshowControls = require('./slideshow-controls');
var slideshowUtils = require('./slideshow-utils');
var favorites = require('./favorites');

var state;
var dom;

var clientWidth;
var clientHeight;

var toggleSlideshow = function(classState) {

	appDom.app.toggleClass('app--is-slideshow', classState);

};

var isSlideshowActive = function() {

	return appDom.app.hasClass('app--is-slideshow');

};

var enterZoomMode = function(mouseX, mouseY) {

	slideshowControls.stopAutoPlay();
	setZoomCoordinates(mouseX, mouseY);
	appDom.app.addClass('app--is-slideshow-zoom');
	addTemporaryZoomHandlers();

};

var exitZoomMode = function() {

	appDom.app.removeClass('app--is-slideshow-zoom');
	removeTemporaryZoomHandlers();

};

var setZoomCoordinates = function(mouseX, mouseY) {

	document.body.style.setProperty('--zoom-img-x', (mouseX / clientWidth * 100) + '%');
	document.body.style.setProperty('--zoom-img-y', (mouseY / clientHeight * 100) + '%');

};

var enterCompareMode = function() {

	var iframe = '<iframe class="slideshow__compare-frame" src="' + location.origin + location.pathname + '?compare=1' + '"></iframe>';

	slideshowControls.stopAutoPlay();
	appDom.slideshowCompare.html(iframe + iframe);
	appDom.app.addClass('app--is-slideshow-compare');

};

var exitCompareMode = function() {

	appDom.app.removeClass('app--is-slideshow-compare');
	appDom.slideshowCompare.html('');

};

var cacheCells = function() {

	dom.cells = appDom.slideshowSlider.find('.slideshow__cell');

};

var setupInitialState = function() {

	state = {};
	state.isMouseMovementClassApplied = false;

};

var removeMovementClass = function() {

	appDom.body.removeClass('app--has-mouse-movement');

	state.isMouseMovementClassApplied = false;

};

var removeMovementClassDebounced = debounce(function() {

	removeMovementClass();

}, 1000);

var addMovementClass = function() {

	// Avoid dom reads by using this flag.
	if (!state.isMouseMovementClassApplied) {

		appDom.body.addClass('app--has-mouse-movement');

		state.isMouseMovementClassApplied = true;

	}

	removeMovementClassDebounced();

};

var toggleTapClass = function(classState) {

	appDom.body.toggleClass('app--has-tapped-focus', classState);

	if (slideshowIntro.isActive()) {

		slideshowIntro.stop();

	}

};

var toggleMouseMovementTargetHoverClass = function(classState) {

	appDom.body.toggleClass('app--has-slideshow-mouse-movement-target-hovered', classState);

};

var toggleSlideshowPositionClasses = function(currentSlide) {

	appDom.slideshow.toggleClass('slideshow--is-first-image', slideshowUtils.isFirstImage(currentSlide));
	appDom.slideshow.toggleClass('slideshow--is-last-image', slideshowUtils.isLastImage(currentSlide, dataMgr.getGalleryData()));

};

var toggleSlideshowFavoriteStatus = function(photoId) {

	appDom.slideshow.toggleClass('slideshow--is-unfavorited-favorite', dataMgr.isFavoritesGallery() && !favorites.isFavorite(photoId));

};

var addTemporaryZoomHandlers = function() {

	appDom.document.on('mousemove.zoom', function(e) {
		
		setZoomCoordinates(e.clientX, e.clientY);
		
	});

	appDom.window.on('resize.zoom', throttle(function() {

		setClientDimensions();
		
	}, 100));

	appDom.slideshow.on('click', '.slideshow__exit-zoom-btn', exitZoomMode);

};

var removeTemporaryZoomHandlers = function() {

	appDom.window.off('.zoom');
	appDom.document.off('.zoom');

};

var removeTemporarySlideshowHandlers = function() {

	appDom.window.off('.slideshow');
	appDom.document.off('.slideshow');

};

// For performance reasons, we only want these handlers to be attached when the
// slideshow is actually running. Namespaces are added to these events so we can
// remove the handlers when the slideshow closes.
var addTemporarySlideshowHandlers = function() {

	if (dataMgr.hasWatermarkEnabled()) {

		// This event has the watermark enabled, so resize it every time the window size changes

		appDom.window.on('resize.slideshow', throttle(function() {

			slideshowImageLoader.resizeWatermark(dataMgr.getSlideshowIndex(), dom.cells);

		}, 100));

	}

	appDom.document.on('device_state_changed.slideshow', function(e) {

		console.log('handling device state change in slideshow...');

		if (bodyStateDetection.wasUpsized(e.oldState, e.newState)) {

			slideshowImageLoader.loadImages(
				dataMgr.getSlideshowIndex(),
				dom.cells,
				{force: true}
			);

		}

		if (slideshowUtils.isSlideshowZoomActive() && ['small', 'medium'].includes(e.newState)) {

			exitZoomMode();
		
		} else if (slideshowUtils.isSlideshowCompareActive() && ['small', 'medium'].includes(e.newState)) {

			exitCompareMode();
			
		}

	});

	appDom.document.on('favorite_added.slideshow favorite_removed.slideshow', function(e) {

		var imgMeta = dataMgr.getImageMeta(e.imageIndex);

		slideshowImageMeta.toggleFavoriteIcon(imgMeta);
		toggleSlideshowFavoriteStatus(imgMeta.photoId);

	});

	appDom.document.on('favorites_updated_via_login.slideshow', function() {

		slideshowImageMeta.toggleFavoriteIcon(dataMgr.getImageMeta());

	});

	if (!appDom.isTouch()) {

		appDom.document.on('keydown.slideshow', function(e) {

			var isAppLoadedAsCompareIframe = appDom.app.hasClass('app--is-slideshow-compare-frame');

			// Ignore escape presses when loaded as compare iframe
			if (isAppLoadedAsCompareIframe && e.keyCode === 27) {
				return;
			}

			if (slideshowUtils.isSlideshowZoomActive()) {

				if (e.keyCode === 27) {

					// Escape key
					exitZoomMode();
					
				}

				return;
				
			} else if (slideshowUtils.isSlideshowCompareActive()) {

				if (e.keyCode === 27) {

					// Escape key
					exitCompareMode();

				}

				return;
				
			}

			// Ignore when coming from form input.

			if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {

				if (e.keyCode === 37) {

					// Left arrow.

					slideshowControls.previous();


				} else if (e.keyCode === 39) {

					// Right arrow.

					slideshowControls.next();

				} else if (e.keyCode === 32) {

					// Space bar.

					appDom.slideshow.find('.slideshow__control--play').click();

				} else if (e.keyCode === 27) {

					// Escape key.

					triggerCustomEvent('slideshow_escape_key_pressed');

				}

			}

		});

		appDom.document.on('mousemove.slideshow', throttle(function() {

			// console.log('mousemove: ', e, e.target);

			addMovementClass();

		}, 500));

		appDom.document.on('mouseenter.slideshow mouseleave.slideshow', '.slideshow__mouse-movement-target', function() {

			toggleMouseMovementTargetHoverClass();

		});

	}

};

var open = function() {

	var index = dataMgr.getSlideshowIndex();
	var cells = slideshowCellsJst.template(dataMgr.getGalleryData());
	var imgMeta = dataMgr.getImageMeta(index);

	setupInitialState();

	appDom.slideshowSlider.html(cells);

	cacheCells();

	slideshowImageLoader.loadImages(index, dom.cells);
	slideshowImageMeta.populate(imgMeta);

	if (slideshowUtils.isSlideshowCompareFrame()) {

		appDom.slideshow.find('.slideshow__compare-select-filename').html(imgMeta.description);
		
	}

	// Need to make sure the slideshow isn't hidden via display: none; before
	// initing slick, otherwise it won't be able to correctly calculate
	// dimensions.
	toggleSlideshow(true);

	appDom.slideshowSlider.slick({
		slide: '.slideshow__cell',
		infinite: false,
		initialSlide: index,
		pauseOnHover: false,
		// Keyboard nav only works when the current cell is focused. This is
		// super annoying and overly complex to work around. We'll implement
		// left/right arrow keys ourselves.
		accessibility: false,
		speed: 400,
		arrows: false,
		// To avoid slick.js inlining the width of every cell, which causes firefox
		// to vomit and then choke to death, we'll turn on variableWidth, which
		// stops slick from doing the width calculation, and we'll use viewport
		// width (vw) in the css to get a full width cell.
		variableWidth: true
	});

	toggleSlideshowPositionClasses(index);
	toggleSlideshowFavoriteStatus(imgMeta.photoId);

	slideshowIntro.start();

	addTemporarySlideshowHandlers();

	setLastPageData(index);

	triggerCustomEvent('slideshow_opened');

};

var close = function() {

	// Close slideshow if open.

	if (isSlideshowActive()) {

		removeTemporarySlideshowHandlers();
		slideshowControls.stopAutoPlay();
		slideshowIntro.stop();

		// Clenup any stateful classes that are used to display buttons/controls.
		toggleTapClass(false);
		removeMovementClass();
		toggleMouseMovementTargetHoverClass(false);

		toggleSlideshow(false);
		appDom.slideshowSlider.slick('unslick');
		appDom.slideshowSlider.empty();
		dom = {};

	}

};

var setLastPageData = function(index) {

	// Set the last page data, this is used by the grid to help it determine if it needs to rebuild the grid markup or not
	dataMgr.setLastPageData({
		type: 'slideshow',
		galleryIndex: dataMgr.getGalleryIndex(),
		slideshowIndex: index
	});

};

var processPage = function() {

	if (dataMgr.isSlideshowState()) {

		open();

	}

};

var setupDom = function() {

	dom = {};

};

var setClientDimensions = function() {

	clientWidth = appDom.html[0].clientWidth;
	clientHeight = appDom.html[0].clientHeight;
	
};

var addEventHandlers = function() {

	if (slideshowUtils.isSlideshowCompareFrame()) {

		appDom.slideshow.on('click', '.slideshow__compare-select-btn', function() {

			top.document.dispatchEvent(new CustomEvent('slideshow_compare_select_btn_clicked', {
				detail: {
					slideshowIndex: dataMgr.getSlideshowIndex()
				}
			}));

		});
		
	} else {

		document.addEventListener('slideshow_compare_select_btn_clicked', function(e) {

			appDom.slideshowSlider.slick('slickGoTo', e.detail.slideshowIndex, true);
			exitCompareMode();

		});
		
	}

	appDom.document.on('gallery_data_ready slideshow_state_pushed', processPage);

	appDom.document.on('image_grid_loading', close);

	appDom.document.on('click', '.slideshow__grid-btn', function() {

		triggerCustomEvent('slideshow_grid_btn_clicked');

	});

	appDom.slideshowImageMeta.on('click', '.slideshow__image-meta-btn', function(e) {

		var $target = $(this);
		var index;

		if ($target.is('.slideshow__image-meta-btn--favorite')) {

			index = dataMgr.getSlideshowIndex();

			triggerCustomEvent('slideshow_favorite_btn_clicked', {
				data: {
					photoId: dataMgr.getImageMeta().photoId,
					imageIndex: index
				}
			});

		} else if ($target.is('.slideshow__image-meta-btn--zoom')) {

			enterZoomMode(e.clientX, e.clientY);

		} else if ($target.is('.slideshow__image-meta-btn--compare')) {

			enterCompareMode();
			
		} else if ($target.is('.slideshow__image-meta-btn--share')) {

			triggerCustomEvent('slideshow_share_btn_clicked');

		} else if ($target.is('.slideshow__image-meta-btn--comment')) {

			triggerCustomEvent('slideshow_comment_btn_clicked');

		} else if ($target.is('.slideshow__image-meta-btn--download')) {

			triggerCustomEvent('slideshow_download_btn_clicked');

		} else if ($target.is('.slideshow__image-meta-btn--add-to-cart')) {

			triggerCustomEvent('slideshow_add_to_cart_btn_clicked', {
				data: {
					photoId: dataMgr.getImageMeta().photoId,
					imageIndex: index
				}
			});

		}

		if (appDom.isTouch()) {

			// Allow propagation if intro is running. The click handler on the
			// slideshow will handle disabling the intro and adding the tap class.

			if (!slideshowIntro.isActive()) {

				// Block propagation so the buttons and controls don't hide.
				e.stopPropagation();

			}

		}

	});

	appDom.slideshowSlider.on('afterChange', function(e, slick, currentSlide) {

		var imgMeta = dataMgr.getImageMeta(currentSlide);

		console.log('afterChange', arguments);

		slideshowImageLoader.loadImages(currentSlide, dom.cells);
		slideshowImageLoader.removeImages(dom.cells, currentSlide);
		slideshowImageMeta.populate(imgMeta);

		if (slideshowUtils.isSlideshowCompareFrame()) {

			appDom.slideshow.find('.slideshow__compare-select-filename').html(imgMeta.description);
			
		}

		if (slideshowUtils.isLastImage(currentSlide, dataMgr.getGalleryData())) {

			// Turn off autoplay if we reached the end.
			slideshowControls.stopAutoPlay();

		}

		toggleSlideshowPositionClasses(currentSlide);
		toggleSlideshowFavoriteStatus(imgMeta.photoId);

		// Removes all controls and buttons. Only applies to touch devices.
		toggleTapClass(false);

		setLastPageData(currentSlide);

		triggerCustomEvent('slideshow_image_changed', {
			data: {
				imageIndex: currentSlide
			}
		});

	});

	appDom.slideshow.on('click', '.slideshow__control--play', function() {

		// Only allow auto playing if not on the last image.
		if (!slideshowUtils.isLastImage(dataMgr.getSlideshowIndex(), dataMgr.getGalleryData())) {

			slideshowControls.toggleAutoPlay();

			// if (appDom.isTouch()) {

			// 	// Block propagation so the buttons and controls don't hide.
			// 	e.stopPropagation();

			// }

		}

	});

	appDom.slideshow.on('click', '.slideshow__control--prev', slideshowControls.previous);
	appDom.slideshow.on('click', '.slideshow__control--next', slideshowControls.next);

	// Pause autoplay if user manually changes image.
	appDom.slideshow.on('click', '.slideshow__control--prev, .slideshow__control--next', slideshowControls.stopAutoPlay);
	appDom.slideshow.on('swipe', slideshowControls.stopAutoPlay);

	if (appDom.isTouch()) {

		appDom.slideshow.on('click', function() {

			toggleTapClass();

		});

		// Hide all buttons and controls when pinch zooming in. Show when
		// pinch zooming all the way out.
		appDom.slideshow.on('gestureend', function(e) {

			// console.log('resize zoom check', e);

			if (e.originalEvent.scale > 1) {

				toggleTapClass(false);

			} else {

				toggleTapClass(true);

			}

		});

	} else {

		appDom.slideshow.on('mouseenter.slideshow mouseleave.slideshow', '.slideshow__control-hover-zone', function() {

			slideshowControls.showControl($(this));

		});

	}

	appDom.document.on('popstate_while_slideshow_zoom_active', exitZoomMode);
	appDom.document.on('popstate_while_slideshow_compare_active', exitCompareMode);

};

var init = function() {

	setupDom();
	addEventHandlers();
	setClientDimensions();

};

module.exports = {

	init: init

};
